import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';

export type PrazoAction = 'cancel' | 'ai' | 'append' | 'remove';

export interface PrazoChangeEvent {
  estimativaId: number;
  action: PrazoAction;
  novoPrazo: number;
  delta: number;
  ts: number;
}

@Injectable({ providedIn: 'root' })
export class StaffPlanBridgeService {
  private _prazoChange$ = new ReplaySubject<PrazoChangeEvent>(1);
  prazoChange$ = this._prazoChange$.asObservable();

  emitPrazoChange(evt: Omit<PrazoChangeEvent, 'ts'>) {
    this._prazoChange$.next({ ...evt, ts: Date.now() });
  }
}
